import type { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { Accordion } from '@/components/layouts/Ir/Mpocket/Accordion'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const ProjectionPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/config-utils-main.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main.js')
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Business Plan and Growth Potential"
        subTitleText="事業計画及び成長可能性"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <Accordion
        id="irp-library-category"
        className="irp-library-category irp-library-category-4"
      />
    </Layout>
  )
}

ProjectionPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: 'IRライブラリー', path: '/ir/library/' },
    { name: '事業計画及び成長可能性', path: '' },
  ]

  return (
    <>
      <Head
        title="事業計画及び成長可能性"
        description="トライアルホールディングスグループのビジネスモデルや、中長期的な成長を実現するための戦略、施策などについて掲載しています。"
        ogp={{ url: 'ir/library/projection/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
